// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.

import React, { useState } from "react";
import "./connexionError.css";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const ConnexionErrorPage: React.FC = () => {
  const [isRetrying, setIsRetrying] = useState(false);
  const navigate = useNavigate();

  // const quertClient = useQueryClient();
  const handleRetry = () => {
    // quertClient.clear();
    setIsRetrying(true);
    setTimeout(() => {
      setIsRetrying(false);
      navigate(-1);
      // window.location.reload();
    }, 2000);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 max-h-screen flex flex-col min-h-screen">
      <header className="w-full px-6 py-3 bg-slate-50 border-b border-solid border-gray-200">
        <div className="max-w-7xl mx-auto flex items-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-500 rounded-full mb-4">
            <img src="/images/chiksoft.png" width={42} alt="Logo" />
          </div>
          <span className="text-3xl text-gray-900 font-bold mt-[-10px] px-2">
            ChikSoft
          </span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-16 bg-slate-200">
        <div className="max-w-2xl mx-auto text-center">
          {/* Error Illustration */}
          <div className="mb-12 relative">
            {/* Floating Elements */}
            <div className="absolute top-8 left-8 w-16 h-16 bg-blue-300 rounded-full opacity-60 animate-pulse"></div>
            <div className="absolute bottom-12 right-12 w-12 h-12 bg-purple-300 rounded-full opacity-40 animate-pulse delay-1000"></div>
            <div className="absolute top-1/2 -left-8 w-8 h-8 bg-gray-200 rounded-full opacity-50 animate-pulse delay-500"></div>
          </div>
          {/* Error Message */}
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Oops! Erreur de connexion
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-lg mx-auto">
              Nous rencontrons des difficultés pour nous connecter à nos
              serveurs. Veuillez vérifier votre connexion Internet et réessayer
              dans un instant.
            </p>
          </div>
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={handleRetry}
              disabled={isRetrying}
              className="!rounded-button whitespace-nowrap cursor-pointer bg-gradient-to-r from-blue-400 to-blue-400 text-white px-8 py-4 text-lg font-semibold hover:from-blue-400 hover:to-purple-400 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed min-w-48"
              // className="!rounded-button whitespace-nowrap cursor-pointer bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 text-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed min-w-48"
              // className="!rounded-button whitespace-nowrap cursor-pointer bg-gradient-to-r from-blue-600 to-red-700 text-white px-8 py-4 text-lg font-semibold hover:from-pink-700 hover:to-blue-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed min-w-48"
            >
              {isRetrying ? (
                <span className="flex items-center justify-center">
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  Chargement...
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  <i className="fas fa-redo mr-2"></i>
                  Réessayer
                </span>
              )}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ConnexionErrorPage;
